import React from 'react';
import ReactTable from '../../../../../../components/Table';
import Typography from '../../../../../../components/Typography';
import { Parser } from "html-to-react";
import { EASMInsight1Colors } from '../../../../../../utils/constants/asset';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import DisabledByDefaultIcon from '@mui/icons-material/DisabledByDefault';
import BarChartComponent from '../../../../../../components/Widgets/barChart';

const Insight1 = (props) => {
    const { data } = props;
    const htmlParser = new Parser();

    const columns = [
        {
            Header: 'Asset',
            accessor: 'asset',
            className: 'w-[450px]',
        },
        {
            Header: 'SPF',
            accessor: 'spf',
            disableSortBy: false,
            Cell: props => {
                const value = props?.value;
                return (  
                    value ?
                        <CheckBoxIcon style={{ color: '#3ADA7A' }} />
                    :
                        <DisabledByDefaultIcon style={{ color: '#CC394F' }} />
                )
            }
        },
        // {
        //     Header: 'DKIM',
        //     accessor: 'dkim',
        //     disableSortBy: false,
        //     Cell: props => {
        //         const value = props?.value;
        //         return (  
        //             value ?
        //                 <CheckBoxIcon style={{ color: '#3ADA7A' }} />
        //             :
        //                 <DisabledByDefaultIcon style={{ color: '#CC394F' }} />
        //         )
        //     }
        // },
        {
            Header: 'DMARC',
            accessor: 'dmarc',
            disableSortBy: false,
            Cell: props => {
                const value = props?.value;
                return (  
                    value ?
                        <CheckBoxIcon style={{ color: '#3ADA7A' }} />
                    :
                        <DisabledByDefaultIcon style={{ color: '#CC394F' }} />
                )
            }
        }
    ];

    const tableData = data?.data?.map((item, index) => {
        return ({
            asset: item?.assetName,
            spf: item?.spf,
            // dkim: item?.dkim,
            dmarc: item?.dmarc,
        })
    });

    const graphData = [];
    data?.graphData?.map((graph) => {
        graphData.push({
            name: graph?.name?.toUpperCase(),
            value: graph?.count
        });
    });

    return (
        <div className='insight-container flex-[100%]'>
            <div className='upper-section'>
                <div className='description'>
                    <Typography variant={"h7"} className={"text-headings"}>Observation</Typography>
                    <div>
                        {htmlParser.parse(data?.observation)}
                    </div>
                    <Typography variant={"h7"} className={"text-headings mt-5"}>Recommended Action</Typography>
                    <div>
                        {htmlParser.parse(data?.recommended_action)}
                    </div>
                </div>
                <div className='graph stackedbar-container'>
                    {
                        data?.graphData &&
                            <BarChartComponent 
                                className={"flex flex-row h-[250px] insight2-bar-chart mt-5"}
                                labelHeight="h-[50px]"
                                graphData={graphData || []} 
                                colors={EASMInsight1Colors}
                            />
                    }
                </div>
            </div>
            <div className='lower-section'>
                <div className='pentest mr-5'>
                    <div className='xl:col-span-12 heading mb-5'>
                        <Typography variant={"h7"} className={"text-headings"}>Assets</Typography>
                    </div>
                    {
                        data?.data &&
                            <ReactTable
                                columns={columns}
                                data={tableData || []}
                                className={"table lg:table-fixed middle-aligned"}
                                headerClassName={"background rounded sticky z-[5] top-0"}
                                bodyClassName={"text-headings"}
                            />
                    }
                </div>
            </div>
        </div>
    );
};

export default Insight1;